var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-pg"},[_c('div',{staticClass:"sign-row"},[_c('div',{staticClass:"confirm-email"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t("Регистрация прошла успешно. Пожалуйста, проверьте свою электронную почту и подтвердите регистрацию на Едином портале, пройдя по ссылке в письме, которое мы вам направим в течение 3 минут."))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }